<template>
    <div id="responsible-choice-widget-component">
        <WidgetWrapperComponent :title="$t('product_report.responsible_choice')" id-widget="product-report-responsible">
            <template v-slot:default>
                <v-row class="text-center">
                    <v-col v-for="item in responsible_items" :key="item.key" cols="6" sm="3">
                        <v-icon color="success" size="32">{{ item.icon }}</v-icon>
                        <p class="font-12 mb-0">{{ $t(item.key) }}</p>
                        <p class="font-10 font-weight-bold success--text mb-0">{{ item.detail }}</p>
                    </v-col>
                </v-row>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>

<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import number from '@/mixin/number'

export default {
    name: 'ResponsibleChoiceWidgetComponent',
    components: {
        WidgetWrapperComponent,
    },
    mixins: [number],
    props: {
        transport: {
            type: Object,
            required: true,
        },
        totals: {
            type: Object,
            required: true,
        },
    },
    computed: {
        responsible_items() {
            return [
                {
                    key: 'product_report.less_transport',
                    icon: 'mdi-truck-outline',
                    detail: this.$t('product_report.less_transport_detail', {
                        weight: this.number(this.transport.avoided_weight_kg),
                    }),
                },
                {
                    key: 'product_report.less_co2',
                    icon: 'mdi-molecule-co2',
                    detail: this.$t('product_report.less_co2_detail', { co2: this.number(this.transport.avoided_co2_kg, 1) }),
                },
                {
                    key: 'product_report.less_packaging',
                    icon: 'mdi-package-variant-closed',
                    detail: this.$t('product_report.less_packaging_detail', {
                        count: this.number(this.transport.avoided_bidons, 0),
                    }),
                },
                {
                    key: 'product_report.less_water_transported',
                    icon: 'mdi-water-off-outline',
                    detail: this.$t('product_report.less_water_detail', { water: this.number(this.totals.water_l) }),
                },
            ]
        },
    },
}
</script>
